module.exports = __webpack_public_path__ + "static/media/bot.7cde7341.png";